import { useEffect, useState, useContext } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Badge from "@mui/material/Badge";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { AuthContext } from "../contexts/AuthContext";
import { getNotificationsUnreadCount } from "../api/notifications";

export default function ForumNotificationsBell() {
  const { player } = useContext(AuthContext);
  const location = useLocation();
  const [count, setCount] = useState(null);

  const show = player != null;

  useEffect(() => {
    if (!show) return;
    let cancelled = false;
    (async () => {
      try {
        const res = await getNotificationsUnreadCount();
        if (!cancelled) setCount(Number(res.unreadCount ?? 0));
      } catch (_) {
        if (!cancelled) setCount(null);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [show, location.pathname]);

  if (!show) return null;

  const hasUnread = count !== null && count > 0;

  return (
    <IconButton
      component={RouterLink}
      to="/notifications"
      color="inherit"
      size="large"
      aria-label="Notifications"
      sx={{
        color: hasUnread ? "#ffd54f" : "#ffffff",
        "&:hover": {
          color: hasUnread ? "#ffe082" : "#ffffff",
        },
      }}
    >
      <Badge badgeContent={count !== null && count > 0 ? count : undefined} color="error">
        <NotificationsIcon />
      </Badge>
    </IconButton>
  );
}
